import { Fragment } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import { SecretStub } from "protogen/secrets_pb";
import { getTypeIcon } from "./SecretTypeSelect";

export default ({
  secrets,
  creators,
  handleSecretClick,
}: {
  secrets: SecretStub[];
  creators: any[];
  handleSecretClick: (secretRef: string) => void;
}) => {
  return (
    <Box
      sx={{
        border: "1px solid #D4D4D4",
        borderRadius: "8px",
      }}
    >
      {secrets.map((secret, index, array) => {
        const creator = creators.find((c) => c.ref === secret.creatorRef);
        return (
          <Fragment key={secret.ref}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: "18px 24px",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "inherit",
                },
              }}
              onClick={() => {
                handleSecretClick(secret.ref);
              }}
            >
              <Box sx={{}}>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#3D3D3D",
                  }}
                >
                  {secret.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#3D3D3D",
                  }}
                >
                  {creator.displayName || ""}
                </Typography>
              </Box>
              <IconButton
                sx={{
                  "&:hover": {
                    backgroundColor: "inherit",
                  },
                }}
                edge="end"
                aria-label="comments"
              >
                {getTypeIcon(secret.valueType)}
              </IconButton>
            </Box>
            {index < array.length - 1 && <Divider />}
          </Fragment>
        );
      })}
    </Box>
  );
};
